"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MultiCurrencyFeatureUtils = void 0;
const enums_1 = require("../enums");
class MultiCurrencyFeatureUtils {
    constructor(enabledFeaturesList) {
        this.allFeatures = Object.values(enums_1.MultiCurrencyFeature);
        this.forbiddingFeatures = [enums_1.MultiCurrencyFeature.Off, enums_1.MultiCurrencyFeature.Base];
        this.enabledFeatures = Array.from(new Set(enabledFeaturesList.replace(/\s/g, '').split(','))).map((value) => value);
    }
    isEnabled(features) {
        if (this.isAllDisabled()) {
            return false;
        }
        if (this.isAllEnabled()) {
            return true;
        }
        return features.every((feature) => this.enabledFeatures.includes(feature));
    }
    isAllEnabled() {
        return this.enabledFeatures.includes(enums_1.MultiCurrencyFeature.All);
    }
    /**
     * Returns true if any feature (exclude MultiCurrencyFeature.Off and MultiCurrencyFeature.Base) is enabled
     * */
    isAnyEnabled() {
        if (this.isAllDisabled()) {
            return false;
        }
        const allowingFeatures = this.allFeatures.filter((feature) => !this.forbiddingFeatures.includes(feature));
        return this.enabledFeatures.some((feature) => allowingFeatures.includes(feature));
    }
    isReplenishmentEnabled() {
        return this.isEnabled([enums_1.MultiCurrencyFeature.Replenishment]);
    }
    isSwapEnabled() {
        return this.isEnabled([enums_1.MultiCurrencyFeature.Swap]);
    }
    isAutoSwapEnabled() {
        return this.isEnabled([enums_1.MultiCurrencyFeature.AutoSwap]);
    }
    isWithdrawalEnabled() {
        return this.isEnabled([enums_1.MultiCurrencyFeature.Withdrawal]);
    }
    isPrimaryWithdrawalEnabled() {
        return this.isEnabled([enums_1.MultiCurrencyFeature.Withdrawal, enums_1.MultiCurrencyFeature.WithdrawalPrimary]);
    }
    isSecondaryWithdrawalEnabled() {
        return this.isEnabled([enums_1.MultiCurrencyFeature.Withdrawal, enums_1.MultiCurrencyFeature.WithdrawalSecondary]);
    }
    isPaypalWithdrawalEnabled() {
        return this.isEnabled([
            enums_1.MultiCurrencyFeature.Withdrawal,
            enums_1.MultiCurrencyFeature.WithdrawalPrimary,
            enums_1.MultiCurrencyFeature.WithdrawalPaypal,
        ]);
    }
    isEnabledForMatches() {
        return this.isEnabled([enums_1.MultiCurrencyFeature.MatchMainUsdt]);
    }
    isEnabledForTournaments() {
        return this.isEnabled([enums_1.MultiCurrencyFeature.TournamentMainUsdt]);
    }
    isUserQuotaSwapEnabled() {
        return this.isEnabled([enums_1.MultiCurrencyFeature.UserQuotaSwap]);
    }
    isUserQuotaWithdrawalEnabled() {
        return this.isEnabled([enums_1.MultiCurrencyFeature.UserQuotaWithdrawal]);
    }
    currencyType() {
        const currencyTypeFeatureFlag = this.enabledFeatures.find((feature) => feature.includes(enums_1.MultiCurrencyFeature.CurrencyType));
        const type = currencyTypeFeatureFlag === null || currencyTypeFeatureFlag === void 0 ? void 0 : currencyTypeFeatureFlag.split('/').pop();
        if (!type) {
            return null;
        }
        return type.toUpperCase();
    }
    isAllDisabled() {
        return this.enabledFeatures.some((feature) => this.forbiddingFeatures.includes(feature));
    }
}
exports.MultiCurrencyFeatureUtils = MultiCurrencyFeatureUtils;
//# sourceMappingURL=multi-currency-feature-utils.js.map